export const ScoreCardStatusEnum = {
  Pending: {key: "pending", value: "pending"},
  Completed: {key: "completed", value: "completed"},
};
